import { NgModule } from '@angular/core';
import { RightPanelComponent } from './right-panel.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import { ItemsModule } from '../../items/items.module';


@NgModule({
  declarations: [
      RightPanelComponent,
  ],
  exports: [
    RightPanelComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslocoModule,
    MatTooltipModule,
    MatButtonModule,
    ItemsModule
  ],
  providers: [

  ]
})
export class RightPanelModule {}
